<template>
	<div class="rangeBox">

		<div class="rangeBox-max">
			<div class="rangeBox-banner">
				<div class="rangeBox-banner-in">
					<div class="rangeBox-banner-in-logo"></div>
				</div>
			</div>

			<div class="rangeBox-nr">
				<div class="rangeBox-nr-left">
					<div class="rangeBox-nr-left-item" :class="[item.xz?'tapItem':'']" v-for="(item,index) in dataArr"
						:key="index" @click="tapItem(index)">{{item.title}}</div>
				</div>
				<div class="rangeBox-nr-right">
					<div class="rangeBox-nr-right-tit">{{dataItem.title}}</div>
					<img :src="$store.state.website + dataItem.image"
						style="width:800px;padding-bottom: 50px;box-sizing: border-box;" v-if="dataItem.image" />
					<div class="rangeBox-nr-right-text">{{dataItem.text}}</div>
				</div>
				<div style="clear:both"></div>
			</div>

			<PageBottom />
		</div>

		<div class="rangeBox-min">
			<div class="rangeBox-min-top" @click="tapMinfanhui()">
				<div class="min-caseBox-top-icon"></div>
				服务范围
			</div>
			<div class="rangeBox-min-box">
				<div class="rangeBox-min-box-left">
					<div class="rangeBox-min-box-left-item" :class="[item.xz?'rangeBox-min-box-left-item-tapItem':'']" v-for="(item,index) in dataArr"
						:key="index" @click="tapItem(index)">{{item.title}}</div>
				</div>
				<div class="rangeBox-min-box-right">
					<div class="rangeBox-min-box-right-tit">{{dataItem.title}}</div>
					<img :src="$store.state.website + dataItem.image"
						style="width:100%;padding-bottom: 0.9375rem;box-sizing: border-box;" v-if="dataItem.image" />
					<div class="rangeBox-min-box-right-text">{{dataItem.text}}</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	import PageBottom from '@/components/PageBottom.vue'
	export default {
		name: 'Home',
		components: {
			PageBottom
		},
		data() {
			return {
				dataArr: [
					// {
					// 	id: 0,
					// 	tit: '服务范围标题1',
					// 	xz: true,
					// 	text: '1服务范围标题服务范围标题服务范围标题服务范围标题服务范围标题服务范围标服务范围1服务范围标题服务范围标题服务范围标题服务范围标题服务范围标题服务范围标服务范围1服务范围标题服务范围标题服务范围标题服务范围标题服务范围标题服务范围标服务范围'
					// },
					// {
					// 	id: 1,
					// 	tit: '服务范围标题2',
					// 	xz: false,
					// 	text: '2服务范围标题服务范围标题服务范围标题服务范围标题服务范围标题服务范围标题服务范围'
					// },
					// {
					// 	id: 2,
					// 	tit: '服务范围标题3',
					// 	xz: false,
					// 	text: '3服务范围标题服务范围标题服务范围标题服务范围标题服务范围标题服务范围标题围'
					// },
					// {
					// 	id: 3,
					// 	tit: '服务范围标题4',
					// 	xz: false,
					// 	text: '4服务范围标题服务范围标题服务范围标题服务范围标标题服务范围标题'
					// },
				],
				dataItem: {},
			}
		},
		mounted() { //声明周期
			window.pageYOffset = 0;
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0

			let that = this;

			//获取服务范围数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/fwfw', {
				// 'aa':1
			}).then(function(response) {
				that.dataArr = response.data.data.reverse();
				that.dataArr.forEach(function(item) {
					item.xz = false
				})
				that.dataArr[0].xz = true;
				that.dataItem = that.dataArr[0];
				// console.log(that.dataArr)

			}).catch(function(error) {
				console.log(error);
			});
		},
		methods: {
			tapItem(index) {
				// console.log(index)
				let that = this;
				that.dataArr.forEach(function(item) {
					item.xz = false;
				})
				that.dataArr[index].xz = true;
				that.dataItem = that.dataArr[index];
			},
			//移动端点击返回
			tapMinfanhui(){
				this.$router.push({
					path: '/'
				})
				this.$store.commit('tapNavItem', 6);
			},
		}
	}
</script>

<style>
	.rangeBox {
		/* background: #fafafa; */
	}

	.rangeBox-banner {
		width: 100%;
		height: 480px;
		background-image: url(../assets/aboutBg.jpg);
		background-size: 100% 100%;
	}

	.rangeBox-banner-in {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		position: relative;
	}

	.rangeBox-banner-in-logo {
		width: 481px;
		height: 70px;
		background-image: url(../assets/fuwufanweiTit.png);
		background-size: 100% 100%;
		position: absolute;
		top: 250px;
		left: 0;
	}

	.rangeBox-nr {
		width: 1200px;
		height: auto;
		margin: 0 auto;
		margin-top: 100px;
		margin-bottom: 100px;
		box-sizing: border-box;
	}

	.rangeBox-nr-left {
		width: 300px;
		height: 100%;
		/* background: red; */
		float: left;
	}

	.rangeBox-nr-right {
		width: 900px;
		height: 100%;
		/* background: pink; */
		float: left;
		padding: 0 50px;
		box-sizing: border-box;
	}

	.rangeBox-nr-left-item {
		width: 100%;
		height: 80px;
		text-align: center;
		line-height: 80px;
		color: #353535;
		font-size: 16px;
		background: #f5f7fa;
		border: 1px solid #eeeeee;
		box-sizing: border-box;
		margin-bottom: -1px;

	}

	.tapItem {
		color: #fed24f;
		background: #ffffff;
		border: 1px solid #fed24f;
		font-weight: bold;
		margin-bottom: 0px;
	}

	.rangeBox-nr-left-item:hover {
		color: #fed24f;
		font-weight: bold;
		background: #ffffff;
		/* border: 1px solid #19b7c8; */
	}

	.rangeBox-nr-right-tit {
		width: 100%;
		font-size: 24px;
		color: #52dedb;
		padding-bottom: 40px;
		box-sizing: border-box;
	}

	.rangeBox-nr-right-text {
		width: 100%;
		font-size: 16px;
		line-height: 28px;
		color: #666666;
	}

	.rangeBox-min {
		display: none;
	}

	@media only screen and (max-width: 1200px) {
		.rangeBox{
			width: 100%;
			height: 100%;
			background: #ffffff;
		}
		.rangeBox-max {
			display: none;
		}

		.rangeBox-min {
			display: block;
			height: 100%;
		}
		.rangeBox-min-top{
			width: 100%;
			height: 2.75rem;
			background: #ffffff;
			border-bottom: 0.0625rem solid #ededed;
			box-sizing: border-box;
			position: relative;
			text-align: center;
			font-size: 1.125rem;
			color: #353535;
			line-height: 2.75rem;
		}
		.rangeBox-min-box{
			width: 100%;
			height: calc(100% - 44px - 49px);
			/* padding: 1.25rem 0rem; */
			box-sizing: border-box;
			/* background: red; */
		}
		.rangeBox-min-box-left{
			width: 7.8125rem;
			height: 100%;
			overflow-y: auto;
			float: left;
			background: #f5f7fa;
		}
		.rangeBox-min-box-right{
			width: calc(100% - 7.8125rem - 10px);
			height: 100%;
			overflow-y: auto;
			float: right;
			padding-right: 0.625rem;
			box-sizing: border-box;
			padding-top: 0.9375rem;
		}
		.rangeBox-min-box-left-item{
			width: 100%;
			height: 3.125rem;
			background: #f5f7fa;
			border: 1px solid #f1f1f1;
			box-sizing: border-box;
			text-align: center;
			line-height: 3.125rem;
			font-size: 0.875rem;
			color: #353535;
			/* margin-top: -0.0625rem; */
		}
		.rangeBox-min-box-left-item-tapItem{
			color: #fed24f;
			background: #ffffff;
			/* border: 1px solid #19b7c8; */
			font-weight: bold;
			/* margin-bottom: 0px; */
			/* margin-top: 0rem; */
			box-sizing: border-box;
			border-right: 1px solid #ffffff;
		}
		.rangeBox-min-box-right-tit{
			width: 100%;
			font-size: 1.25rem;
			color: #52dedb;
			padding-bottom: 0.9375rem;
			/* padding-top: 1.25rem; */
			box-sizing: border-box;
		}
		.rangeBox-min-box-right-text{
			width: 100%;
			font-size: 0.875rem;
			line-height: 28px;
			color: #666666;
			
		}
	}
</style>
